"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgRedirect = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_REDIRECT", width: "1em", height: "1em", viewBox: "0 0 16 14" }, props),
    React.createElement("path", { d: "M9.298 1.707A1 1 0 0 1 10.71.293l4.996 5a.997.997 0 0 1-.005 1.42l-4.991 4.994a.999.999 0 1 1-1.413-1.414L12.588 7h-6.58c-1.142 0-1.898.355-2.43.836-.553.5-.93 1.198-1.178 1.97a8.945 8.945 0 0 0-.384 2.16 9.718 9.718 0 0 0-.009.955V12.93a1 1 0 0 1-1.993.141L1.011 13l-.997.071v-.011l-.002-.021a5.379 5.379 0 0 1-.01-.325c-.004-.212-.002-.51.02-.867.041-.708.16-1.672.475-2.653.314-.978.842-2.03 1.741-2.842C3.158 5.52 4.4 5 6.008 5h6.58l-3.29-3.293Z" }))); };
exports.default = SvgRedirect;
